<template>
  <div v-if="files && files.length > 0" class="task-report-files-wrapper d-inline-flex align-center">
    <VMenu
      v-model="isOpen"
      :close-on-content-click="false"
      close-delay="200"
      location="bottom start"
      offset="8"
      content-class="entity-form-menu"
      :z-index="2500"
    >
      <template #activator="{ props: menuProps }">
        <div
          v-bind="menuProps"
          class="report-files-trigger d-inline-flex align-center ga-1 px-2 py-1 rounded cursor-pointer border select-none"
          @click.stop
        >
          <VIcon icon="ri-attachment-line" size="16" class="text-medium-emphasis" />
          <span class="text-body-2 font-weight-medium text-high-emphasis">
            {{ files.length }}
          </span>
        </div>
      </template>

      <!-- Карточка со списком файлов вложений через системный FileList -->
      <VCard
        class="rounded-lg elevation-4 border bg-surface pa-4"
        min-width="300"
        max-width="380"
        @click.stop
      >
        <div class="text-body-1 font-weight-medium text-high-emphasis mb-2">
          Вложения к отчету
        </div>

        <FileList
          :items="files"
          :disabled="true"
          :show-delete="false"
        />
      </VCard>
    </VMenu>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import FileList from '@/modules/files/components/FileList.vue'
import type { IExistingFile } from '@/modules/files/types/IExistingFile'

interface Props {
  files: IExistingFile[]
}

withDefaults(defineProps<Props>(), {
  files: () => [],
})

const isOpen = ref(false)
</script>

<style scoped>
.report-files-trigger {
  background-color: rgb(var(--v-theme-surface));
  border-color: rgba(var(--v-border-color), var(--v-border-opacity)) !important;
  transition: all 0.2s ease;
}

.report-files-trigger:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.04);
  border-color: rgba(var(--v-theme-primary), 0.4) !important;
}
</style>
